import { UserType } from '@types';

import { ImmerStateCreator, StatusAction } from '../store.type';

import {
  getUserAction,
  updateUrlAvatarUserAction,
  UpdateUrlAvatarUserActionPayloadType,
  updateUserAction,
  UpdateUserActionPayloadType,
} from './user.action';

/** StatusAction
 *
 ----------------------------- Lifecycle ----------------------------------
 IDLE => LOADING => SUCCEEDED or FAILED
 *
 */

export type UserSliceType = {
  /** selectors **/
  user: UserType
  /** actions **/
  getUserAction: {
    call: () => void
    status: StatusAction
  }
  updateUserAction: {
    call: (payload: UpdateUserActionPayloadType) => void
    status: StatusAction
  }
  updateUrlAvatarUserAction: {
    call: (payload: UpdateUrlAvatarUserActionPayloadType) => void
    status: StatusAction
  }
};

const userSlice: ImmerStateCreator<UserSliceType> = (set) => ({
  user: undefined,
  /**  **/
  getUserAction: {
    call: () => getUserAction(set)(),
    status: 'IDLE',
  },
  updateUserAction: {
    call: (payload) => updateUserAction(set)(payload),
    status: 'IDLE',
  },
  updateUrlAvatarUserAction: {
    call: (payload) => updateUrlAvatarUserAction(set)(payload),
    status: 'IDLE',
  },
});

export default userSlice;
